import angular from 'angular';

(function() {
    'use strict';

    var core = angular.module('app.core');

    // ------------------
    // Configuration de la gestion de la sécurité sur chaque changement de route
    // ------------------
    core.run(routeSecurity);

    routeSecurity.$inject = ['$transitions', '$log', '$rootScope', 'AUTH_EVENTS', 'AuthSvc'];
    function routeSecurity($transitions, $log, $rootScope, AUTH_EVENTS, AuthSvc) {
        $transitions.onBefore({}, function(trans) {
            var targetState = trans.targetState();
            $log.debug('Next route: ' + JSON.stringify(targetState.name()));
            var authorizedRole =
                targetState &&
                targetState._definition &&
                targetState._definition.data &&
                targetState._definition.data.authorizedRole;

            var unallowed = authorizedRole && !AuthSvc.isAuthorized(authorizedRole);
            var result = !unallowed;
            if (unallowed) {
                if (AuthSvc.isAuthenticated()) {
                    $log.debug('Not allowed');
                    // user is not allowed
                    $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                } else {
                    $log.debug('Not auth');

                    // Tente de réauthentifier automatiquement l'utilisateur (pour le cas des reload)
                    result = AuthSvc.relogin().then(function(user) {
                        var result;
                        if (AuthSvc.isAuthenticated()) {
                            $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, user);
                            result = true;
                        } else {
                            // user is not logged in
                            AuthSvc.saveAttemptState(targetState);
                            $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);

                            // Accès à un emplacement nécessitant une authentification
                            var $state = trans.router.stateService;
                            result = $state.target('app.login');
                        }
                        return result;
                    });
                }
            }
            return result;
        });
    }

    //core.run(traceTransitions);
    //traceTransitions.$inject = ['$trace'];
    //function traceTransitions($trace) {
    //	  $trace.enable("TRANSITION", "VIEWCONFIG");
    //}
})();
